import { render, staticRenderFns } from "./Product-barcode.vue?vue&type=template&id=36fdde7e"
import script from "./Product-barcode.vue?vue&type=script&lang=js"
export * from "./Product-barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports